import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import colorConfigs from "../../configs/colorConfigs";
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import SidebarItem from "./SidebarItem";


const SidebarItemCollapse = ({ item, onDataChange,selectedProjectID }) => {
    const [open, setOpen] = useState(false);

    const handleChange=()=>{
      //onDataChange(item)
      setOpen(!open)
    }
    
    return (
        item ? (
          <>
            <ListItemButton
              onClick={() => handleChange(item)}
              sx={{
                "&: hover": {
                  backgroundColor: colorConfigs.sidebar.hoverBg
                },
                paddingY: "12px",
                paddingX: "24px"
              }}
            >
            {/*   <ListItemIcon sx={{
                color: colorConfigs.sidebar.color
              }}>
                {item.sidebarProps.icon && item.sidebarProps.icon}
              </ListItemIcon> */}
            <ListItemText
                onClick={()=> selectedProjectID(item.project_id)}
                disableTypography
                primary={
                  <Typography>
                    {item.projectName}
                  </Typography>
                }
              />
              {open ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
            </ListItemButton>
            <Collapse in={open} timeout="auto">
              <List>
                {item.parts?.map((route, index) => (
                  route ? (
                    route.parts ? (
                      <SidebarItemCollapse selectedProjectID={selectedProjectID} item={route} key={index} onDataChange={onDataChange}/>
                    ) : (
                      <SidebarItem item={route} key={index} projectId={item.project_id} onDataChange={onDataChange} />
                    )
                  ) : null
                ))}
              </List>
            </Collapse>
          </>
        ) : null
      );
    };
    
export default SidebarItemCollapse;